export default __webpack_public_path__ + "static/media/28.d611f8ef.jpg";